export const webRoutes = [
  {
    name: "index",
    path: "/web/index",
    component: () => import("@/views/index.vue"),
    meta: {
      title: "首页",
      isAuth: false,
    },
  }, 
  {
    name: "txt",
    path: "/web/txt",
    component: () => import("@/views/web/txt.vue"),
    meta: {
      title: "文本",
      isAuth: true,
    },
  },
  {
    name: "img",
    path: "/web/img",
    component: () => import("@/views/web/img.vue"),
    meta: {
      title: "图片",
      isAuth: true,
    },
  },
  {
    name: "tvideo",
    path: "/web/t-video",
    component: () => import("@/views/web/tvideo.vue"),
    meta: {
      title: "视频",
      isAuth: true,
    },
  },
  {
    name: "ivideo",
    path: "/web/i-video",
    component: () => import("@/views/web/ivideo.vue"),
    meta: {
      title: "视频",
      isAuth: true,
    },
  },
  {
    name: "writing",
    path: "/web/writing",
    component: () => import("@/views/web/writing.vue"),
    meta: {
      title: "文生文",
      isAuth: true,
    },
  },
  {
    name: "model",
    path: "/web/model",
    component: () => import("@/views/web/model.vue"),
    meta: {
      title: "模型",
      isAuth: true,
    },
  },
  {
    name: "wording",
    path: "/web/wording",
    component: () => import("@/views/web/wording.vue"),
    meta: {
      title: "话术",
      isAuth: true,
    },
  },
  {
    name: "material",
    path: "/web/material",
    component: () => import("@/views/web/material.vue"),
    meta: {
      title: "素材",
      isAuth: true,
    },
  },
];